import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Grid } from '@/components/ui/Grid';
import { Dd, Dl, Dt } from '@/components/ui/DefinitionList';
import { optionalBooleanFormat } from '@/components/utils/formatter';
import { ViewProps } from './ViewProps';

export const OrderByDoctor: FC<ViewProps> = ({ result, editLink }) => {
  return (
    <Panel>
      <Link to={`${editLink}#order_by_doctor`}>
        <Headding icon={<Edit icon={16} />}>医師の指示対象</Headding>
      </Link>
      <Item>
        <Grid>
          <Dl>
            <Dt>指示</Dt>
            <Dd>{optionalBooleanFormat(result.orderByDoctor ?? false, 'あり', 'なし')}</Dd>
          </Dl>
        </Grid>
      </Item>
    </Panel>
  );
};
